module.exports = __webpack_public_path__ + "static/media/receipt.5f7eb0ee.svg";